import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "hstack gap-2 align-self-end" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]

import { computed, ref, watch } from 'vue';
import { BTableOptions, BSelectOptionsNumber } from "@/components/BTable/BTable.types";


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationDefault',
  props: {
    value: {},
    headerSlotClass: { default: '' },
    announce: { type: Boolean, default: false }
  },
  emits: ['optionChange'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;
    
    var options = ref(props.value as BTableOptions);    
    
    const itemsPerPageOptions = [
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 }
        ] as BSelectOptionsNumber[];    

    var maxPage = computed((): number => {
        return Math.ceil(options.value.totalItemCount / options.value.itemsPerPage);
    });

    var itemStart = computed((): number => {
        return Math.min(
            options.value.totalItemCount,
            (options.value.page - 1) * options.value.itemsPerPage + 1
        );
    });
    
    var itemEnd = computed((): number => {
        return Math.min(
            options.value.totalItemCount,
            options.value.page * options.value.itemsPerPage
        );
    });

    var canGoNext = computed((): boolean => {
        return canGo(+1);
    });

    var canGoPrevious = computed((): boolean => {
        return canGo(-1);
    });

    function first() {
        goToPage(1);
    }

    function last() {
        goToPage(maxPage.value);
    }

    function goToPage(pageNumber: number) {       
        options.value.page = pageNumber;
        emits("optionChange", options.value);
    }
    
    function go(deltaPage: number) {
        goToPage(Math.max(1, Math.min(maxPage.value, options.value.page + deltaPage)));
    }
    
    function canGo(deltaPage: number) {
        var newPage = options.value.page + deltaPage;
        return newPage >= 1 && newPage <= maxPage.value;
    }
    
    function setItemsPerPage(e:any) { 
        options.value.itemsPerPage = options.value.itemsPerPage;
        options.value.page = 1;
        emits("optionChange", options.value);
    }

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(options).totalItemCount >= 0)
      ? (_openBlock(), _createElementBlock("span", _mergeProps({
          key: 0,
          class: "b-table-header-info"
        }, __props.announce ? {role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true'} : {}), _toDisplayString(_unref(itemStart)) + "-" + _toDisplayString(_unref(itemEnd)) + " of " + _toDisplayString(_unref(options).totalItemCount), 17))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("select", {
      class: "form-select b-table-header-pagesize py-1 border border-dark",
      "aria-label": "Select Page Size",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.value.itemsPerPage) = $event)),
      onChange: setItemsPerPage
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(itemsPerPageOptions, (option) => {
        return _createElementVNode("option", {
          value: option.value
        }, _toDisplayString(option.text), 9, _hoisted_2)
      }), 64))
    ], 544), [
      [
        _vModelSelect,
        __props.value.itemsPerPage,
        void 0,
        { number: true }
      ]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("button", {
      type: "button",
      class: _normalizeClass('btn btn-sm ' + (canGo(-1)?'border border-dark':'')),
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (first()), ["prevent"])),
      disabled: !_unref(canGoPrevious),
      "aria-label": "First Page"
    }, [...(_cache[5] || (_cache[5] = [
      _createElementVNode("i", {
        class: "bi bi-chevron-double-left",
        "aria-hidden": "true"
      }, null, -1)
    ]))], 10, _hoisted_3)), [
      [_directive_tooltip, `First Page`]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("button", {
      type: "button",
      class: _normalizeClass('btn btn-sm ' + (canGo(-1)?'border border-dark':'')),
      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (go(-1)), ["prevent"])),
      disabled: !_unref(canGoPrevious),
      "aria-label": "Previous Page"
    }, [...(_cache[6] || (_cache[6] = [
      _createElementVNode("i", {
        class: "bi bi-chevron-left",
        "aria-hidden": "true"
      }, null, -1)
    ]))], 10, _hoisted_4)), [
      [_directive_tooltip, `Previous Page`]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("button", {
      type: "button",
      class: _normalizeClass('btn btn-sm ' + (canGo(+1)?'border border-dark':'')),
      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (go(+1)), ["prevent"])),
      disabled: !_unref(canGoNext),
      "aria-label": "Next Page"
    }, [...(_cache[7] || (_cache[7] = [
      _createElementVNode("i", {
        class: "bi bi-chevron-right",
        "aria-hidden": "true"
      }, null, -1)
    ]))], 10, _hoisted_5)), [
      [_directive_tooltip, `Next Page`]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("button", {
      type: "button",
      class: _normalizeClass('btn btn-sm ' + (canGo(+1)?'border border-dark':'')),
      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (last()), ["prevent"])),
      disabled: !_unref(canGoNext),
      "aria-label": "Last Page"
    }, [...(_cache[8] || (_cache[8] = [
      _createElementVNode("i", {
        class: "bi bi-chevron-double-right",
        "aria-hidden": "true"
      }, null, -1)
    ]))], 10, _hoisted_6)), [
      [_directive_tooltip, `Last Page`]
    ])
  ]))
}
}

})